"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How far in advance should I book my reservation?",
  answer: "We recommend booking at least 48 hours in advance to ensure vehicle availability, especially during peak seasons and weekends. For special events like weddings or proms, booking several months ahead is advisable to secure your preferred vehicle."
}, {
  question: "What is your cancellation policy?",
  answer: "Cancellations made 24 hours or more before the scheduled pickup time will receive a full refund. Cancellations within 24 hours may be subject to a cancellation fee. Please refer to our full terms and conditions for specific details regarding your reservation type."
}, {
  question: "Are your vehicles cleaned and sanitized?",
  answer: "Yes, absolutely. We maintain the highest standards of cleanliness and hygiene. Every vehicle in our fleet is thoroughly cleaned, detailed, and sanitized before and after each trip to ensure a safe, pristine, and comfortable experience for our clients."
}, {
  question: "Can I request a specific vehicle model?",
  answer: "While we cannot always guarantee a specific make or model due to scheduling, maintenance, and unforeseen circumstances, you can certainly request a vehicle category (e.g., Luxury Sedan, Stretch Limo, Party Bus). We will do our utmost to accommodate your specific preferences."
}, {
  question: "Do you provide services for airport transfers?",
  answer: "Yes, we offer reliable and punctual airport transfer services. We actively monitor flight schedules to ensure your chauffeur is ready and waiting when you arrive, providing a seamless and stress-free transition from the airport to your final destination."
}];
export default function FrequentlyAskedQuestions() {
  return <section id="frequently-asked-questions" className="bg-dark-section text-dark-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-display font-semibold text-3xl md:text-4xl text-center mb-8">
            Reservation FAQ
          </h2>
          
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="glass-effect border-white/10 px-6 data-[state=open]:bg-white/15 transition-colors duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
                <AccordionTrigger className="text-white hover:no-underline hover:text-secondary-light transition-colors [&>svg]:text-secondary [&>svg]:stroke-2 text-base md:text-lg py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-white/80 pb-6 text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}